import { Form, Field, FormElement, FieldWrapper, FieldRenderProps, FormRenderProps } from '@progress/kendo-react-form';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { Input } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { docLinks } from './Configuration';
import { DocLinks, PubListEntry, NewRunDate } from '../services/interfaces';
import { Button } from 'reactstrap';
import { useContext, useEffect, useState } from 'react';
import { SubmissionContext } from './SubmissionFormContext';
import { PageContext } from './PageContext';
import { getPubList } from '../services/apiService';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { CompositeFilterDescriptor,FilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { IntlProvider, LocalizationProvider, IntlProviderProps } from '@progress/kendo-react-intl';
import { Grid, GridColumn, GridCustomCellProps } from '@progress/kendo-react-grid';
import { DateTime } from 'luxon';

function RunDates(){
    const subContext=useContext(SubmissionContext);
    const pageContext=useContext(PageContext);
    const [pubList, setPubList] = useState<PubListEntry[]>([]);
    const [startDate, setStartDate]= useState<Date>();
    const [endDate, setEndDate]=useState<Date>();
    const [pub,setPub]=useState<PubListEntry>();

    const addDate=()=>{
        var pubName="";
        var pubNum=undefined;
        var start=undefined;
        var end=undefined;
        var newRunDates: NewRunDate[] = subContext?.submitForm.runDates||[];
        if (pub && startDate) {
            start = startDate;
            pubName=pub.pubName;
            pubNum=pub.pubNum;
            if (endDate){
                end = endDate;
            }else{
                end = startDate;
            }
            const newRunDate:NewRunDate={
                pubName:pubName,
                pubNum:pubNum,
                startDate:start,
                endDate:end||start
            };
            //subContext?.setSubmitForm(prevObject=>({...prevObject,runDates:[...subContext?.submitForm.runDates,newRunDate]}));
            newRunDates.push(newRunDate);
            if (endDate){
                const newEndDate:NewRunDate={
                    pubName:pubName,
                    pubNum:pubNum,
                    startDate:end,
                    endDate:end
                }
                newRunDates.push(newEndDate);
                //subContext?.setSubmitForm(prevObject=>({...prevObject,runDates:[...subContext?.submitForm.runDates,newEndDate]}));
            }
            subContext?.setSubmitForm(prevObject=>({...prevObject,runDates:newRunDates}));
            CheckState();
        }
    }

    const CheckState=()=>{
        validateDates();
        console.log(subContext?.submitForm);
    }

    const setStartDateVal=(event:DatePickerChangeEvent)=>{
        setStartDate(event.value || undefined);
    }

    const setEndDateVal=(event:DatePickerChangeEvent)=>{
        setEndDate(event.value || undefined);
    }

    const setPubVal=(event:DropDownListChangeEvent)=>{
        setPub(event.value||undefined);
    }

    const setSubmitDeadline=(event:DropDownListChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,deadlineType:event.value}));    }


    const validateDates=()=>{
        if ((subContext?.submitForm.runDates ?? []).length > 0){
            setFormValid(true);
        }else{
            setFormValid(false);
        }
    }

    const setFormValid=(val:boolean)=>{
        const subValid = subContext?.submitValid;
        if (subValid) {
            subValid.dates = true;
            if (subContext) {
                subContext.submitValid = subValid;
            }
        }
    }


    const CustomCell: React.FC<GridCustomCellProps> = (props) => {
        console.log(props);
        const date:Date = props.field ? props.dataItem[props.field] : undefined;
        return (
            <td
                {...props.tdProps}
            >
                {date?.toLocaleString(pageContext?.glSettings.Locale || "en-US", DateTime.DATE_SHORT)}
            </td>
        );
    };

    useEffect(()=>{
        getPubList().then(data=>{
            var filter:CompositeFilterDescriptor ={
                logic:"and",
                filters:[
                    {field:"isActivePub", value:1,operator:"equals"},
                    {field:"tmpChar", value:subContext?.submitForm.site.code,operator:"equals"}
                ]
            }
            if (subContext?.submitForm.adType.value=="RM"){
                filter.filters.push({field:"tmpChar2", value:"ONLINE", operator:"equals"});
            }else{
                filter.filters.push({field:"tmpChar2", value:"PRINT", operator:"equals"});
            }

            const newData:PubListEntry[] = filterBy(data, filter);
            console.log(newData);
            setPubList(newData);
        });
    },[])

    return(
        <div>
        <h5>PUBLICATION & RUN DATES</h5>
        <FieldWrapper>
            <Label>Publication:</Label>
            <DropDownList
                data={pubList}
                textField='pubName'
                dataItemKey='numNum'
                fillMode={"outline"}
                onChange={setPubVal}              
            />
        </FieldWrapper>
        <FieldWrapper>
            <Label>First Date:</Label>
            <LocalizationProvider language={pageContext?.glSettings.Locale||"en-US"}>
                <IntlProvider locale={pageContext?.glSettings.Locale||"en-US"}>            
                    <DatePicker onChange={setStartDateVal} min={new Date()}/>
                </IntlProvider>
            </LocalizationProvider>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Last Date:</Label>
            <DatePicker onChange={setEndDateVal} min={new Date()}/>
        </FieldWrapper>
        <FieldWrapper>
            <Button onClick={addDate}>Add Date</Button>
            <Grid className='mt-3' data={subContext?.submitForm.runDates}>
                <GridColumn title='Pub Name' field='pubName'/>
                <GridColumn title='Pub Num' field='pubNum'/>
                <GridColumn title='Start Date' field='startDate'cells={{ data: CustomCell }} />
                <GridColumn title='End Date' field='endDate'cells={{ data: CustomCell }} />
            </Grid>
        </FieldWrapper>

        <FieldWrapper>
            <Label>Deadline:</Label>
            <DropDownList
                data={[
                    { text: "Main", value: "MAIN" },
                    { text: "Soft", value: "SOFT" },
                    { text: "Early Run", value: "EARLY RUN" },
                    { text: "Advanced", value: "ADVANCED" }
                ]}
                textField='text'
                dataItemKey='value'
                onChange={setSubmitDeadline}
                value={subContext?.submitForm.deadlineType}
                fillMode={"outline"}
                defaultItem={{ text: "Main", value: "MAIN" }}
            />
        </FieldWrapper>
    </div>
    )
}

export const SubmitRunDates =(
    <RunDates/>
)